import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchApi } from '@/lib/api/client';
import { profileKeys } from '@/hooks/api/query-keys';

// ============ Types ============

export interface UserProfile {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  companyId: string;
  companyName: string;
  avatarUrl?: string | null;
}

export interface UpdateProfileDto {
  firstName: string;
  lastName: string;
}

// ============ Query Hooks ============

export function useProfile() {
  return useQuery({
    queryKey: profileKeys.me(),
    queryFn: () => fetchApi<UserProfile>('/auth/me'),
  });
}

// ============ Mutation Hooks ============

export function useUpdateProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateProfileDto) =>
      fetchApi<UserProfile>('/auth/me', {
        method: 'PUT',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: profileKeys.me() });
    },
  });
}
